@if (isDesign) {
  <fb-laser-widget-placeholder />
} @else if (isPrinting) {
  <fb-laser-widget-print [data]="data()" [isCompleted]="isCompleted()" [isTemplatePrint]="isTemplatePrint" />
} @else if (isPreview || isEmrReadonly) {
  <fb-laser-widget-preview [data]="data()" [isCompleted]="isCompleted()" [isEmrReadonly]="isEmrReadonly" />
} @else {
  <fb-laser-widget-edit
    [data]="data()"
    [appointmentId]="appointmentIdValue()"
    [treatmentId]="treatmentIdValue()"
    [patientRemoteId]="patientRemoteIdValue()"
    [markerTargets]="getScribeMarkerTargets()"
    (update)="updatePayload($event)"
  />
}
